import { Theme, createStyles } from "@material-ui/core";

export const styles = ({spacing}: Theme) => createStyles({
    title: {
        textTransform: "uppercase"
    }
});



// WEBPACK FOOTER //
// ./src/components/CustomerQuotations/CustomerQuotations.style.tsx